<template>
  <div class="widget_loading_success">
    <div v-if="is_loading && !completed" class="loading-widget">
      <loading
        :height="50"
        color="#0065E1"
        :opacity="0"
        :width="50"
        :active.sync="is_loading"
        :is-full-page="false"
        :can-cancel="false"
        background-color="transparent"
        class="loader"
      ></loading>

      <h1>Processing Payment</h1>
      <h3>Please wait</h3>
    </div>
    <div v-if="completed" class="completed-widget">
      <img src="" class="icon" />
      <h1>Appointment booked successfully</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget_loading_success",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    completed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      is_loading: true,
    };
  },
  watch: {
    loading: function (val) {
      this.is_loading = val;
    },
  },
  mounted() {
    let vm = this;
    vm.is_loading = vm.loading;
  },
  methods: {
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>
<style lang="scss" scoped>
.widget_loading_success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .loading-widget {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    position: relative;
    height: 200px;
    h1 {
      color: #0065e1;
      margin-bottom: 15px;
      font-size: 20px;
    }
    h3 {
      font-size: 15px;
      color: #000;
    }
  }
  .completed-widget {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    position: relative;
    height: 200px;
    .icon {
      width: 100px;
      margin-bottom: 30px;
    }
    h1 {
      color: #0065e1;
      margin-bottom: 15px;
      font-size: 16px;
    }
    h3 {
      font-size: 15px;
      color: #000;
    }
  }
}
</style>
